import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import {
  SchedulePageSkeletonFrame,
  YourTimeSkeleton,
} from 'pages/schedule/SelectLessonTime/redesign/skeleton-parts'
import useStyles from './styles'

// Form card placeholder, also used on its own while the signed-in golfer's
// students load. Uses the loaded form card's own class so it matches.
export const FormCardSkeleton = () => {
  const classes = useStyles()
  return (
    <div
      className={classes.formCard}
      aria-busy="true"
      data-testid="select-student-form-skeleton"
    >
      <Skeleton variant="text" animation="wave" width="55%" height={36} />
      <Skeleton variant="text" animation="wave" width="70%" />
      <Skeleton
        variant="rect"
        animation="wave"
        width={180}
        height={38}
        style={{ borderRadius: 19, margin: '20px 0' }}
      />
      <Skeleton
        variant="rect"
        animation="wave"
        height={52}
        style={{ borderRadius: 12, marginBottom: 16 }}
      />
      <Skeleton
        variant="rect"
        animation="wave"
        height={52}
        style={{ borderRadius: 12 }}
      />
    </div>
  )
}

// Placeholder for the redesigned step 2 while the lesson type and feature
// flags load. Same frame as the loaded page (grey background, back row or
// compact summary, "Your time" card, form card, summary column on desktop) so
// nothing shifts.
const SelectStudentSkeletonRedesign = () => {
  const classes = useStyles()
  return (
    <SchedulePageSkeletonFrame testId="select-student-skeleton-redesign">
      {() => (
        <div className={classes.stack}>
          <YourTimeSkeleton className={classes.yourTime} />
          <FormCardSkeleton />
        </div>
      )}
    </SchedulePageSkeletonFrame>
  )
}

export default SelectStudentSkeletonRedesign
